import { Grid, Typography, Box } from "@mui/material";
import { ResponsivePie } from "@nivo/pie";
import React from "react";
import _ from "lodash";

export const InterestsPie = (props) => {
    let selectedJob = props.job;
    let [difference, setDifference] = React.useState("Please click outer circle");
    let [yourValue, setYourValue] = React.useState("Please click outer circle");
    let [jobValue, setJobValue] = React.useState("Please click outer circle");
    let [textColor, setTextColor] = React.useState("#000000");

    let candidateInterestsData = props.candidate.interestsGraphData;

    const interests_scale = selectedJob && selectedJob.ONET_interests ? _.sum(Object.entries(selectedJob.ONET_interests).map(([key, value]) => Number(value))) : false
    const newdata = selectedJob && selectedJob.ONET_interests ? Object.entries(selectedJob.ONET_interests).map(([key, value]) => {
      return {
        id: key,
        label: key,
        value: interests_scale ? Math.round((value / interests_scale) * 100, 2) : 16.66
      }
    }) : [];

    const dataToPress = (e) => {
      let candidateData;
      _.each(candidateInterestsData, (d) => {
        if (d.name === e.id){
          candidateData = d;
        }
      });
      difference = (candidateData.value - e.value);
      let differenceNumber = difference;
      difference = difference.toFixed(1) + "%";
      setDifference(difference);
      setYourValue(`${candidateData.name} : ${candidateData.value}%`)
      setJobValue(`${e.id} : ${e.value}%`)

      if (differenceNumber < 0){
        setTextColor("#E16618")
      } else {
        setTextColor("#87D190")
      }

    };

    const loadpieChart = () => {
      return <Grid container sx={{ overflowY: 'auto', height: "100%" }} >
        <Grid item size={{xs:12}} sm={12} md={12}>
        <div style={{
          height: 220,
          position: "relative",
          minWidth: 280,
          maxWidth: 450,
          zIndex: 1
        }}>
            <ResponsivePie
              margin={{ top: 20, right: 100, bottom: 10, left: 10 }}
              //pixelRatio={1.5}
              slicesLabelsTextColor="#ffffff"
              enableSlicesLabels={true}
              innerRadius={0.70}
              data={newdata}
              onClick={dataToPress}
              isInteractive={false}
              slicesLabelsSkipAngle={10}
              colors={[
                "#948BFF",
                "#34CFFF",
                "#FFB61C",
                "#FF5255",
                "#53D28E",
                "#D89E22",
              ]}
              enableRadialLabels={false}
              legends={[
                {
                  anchor: "right",
                  direction: "column",
                  translateX: 110,
                  itemWidth: 100,
                  itemHeight: 18,
                  // itemTextColor: "#999",
                  symbolSize: 10,
                  symbolShape: "square",
                  itemTextColor: "#5A6375",
                },
              ]}
              theme={{
                legends: {
                  text: {
                    fontFamily: "Montserrat",
                  },
                },
              }}
            />
            <div style={{
              position: "absolute",
              top: 0,
              zIndex: -1,
              height: "100%",
              width: "100%",
            }}>
              <ResponsivePie
                sx={{ position: "absolute", top: 0, zIndex: -1, height: "100%", width: "100%" }}
                slicesLabelsTextColor="#ffffff"
                slicesLabelsSkipAngle={10}
                colors={[
                  "#948BFF",
                  "#34CFFF",
                  "#FFB61C",
                  "#FF5255",
                  "#53D28E",
                  "#D89E22",
                ]}
                enableSlicesLabels={true}
                margin={{ top: 60, right: 90, bottom: 50, left: 0 }}
                isInteractive={false}
                onClick={dataToPress}
                innerRadius={0.6}
                data={candidateInterestsData}
                enableRadialLabels={false}
              />
            </div>
          </div>
          <Typography variant="body2" sx={{ fontSize: 11, color: "#5A6375", textAlign: "center", mt: 2.5 }}>
          Outer circle: <Box component="strong" sx={{ mr: 3.75 }}>Job</Box>
          Inner Circle: <strong>You</strong>
        </Typography>
        </Grid>
        <Grid item sm={1}> </Grid>
        <Grid item size={{xs:12}} sm={12} md={12}>
          <Box sx={{ textAlign: "center" }}>
          <Typography sx={{ mt: 1.875 }}> Your Profile </Typography>
          <Typography variant="body2" sx={{ mt: 1.875, mb: 1.875 }}> {yourValue} </Typography>
          <Typography> Job Requirement</Typography>
          <Typography variant="body2" sx={{ mt: 1.875, mb: 1.875 }}> {jobValue} </Typography>
          <Typography> Interest Gap </Typography>
          <Typography variant="body2" style={{"color": textColor}}  sx={{ mt: 1.875, mb: 1.875 }}> {difference} </Typography>
          </Box>
        </Grid>
        <Grid container justifyContent="center"  spacing={4}>
          <Grid style={{height: 100}} item size={{xs:12}}></Grid>
        </Grid>
      </Grid>
    }
    
    let dataToRender = <> </>;
    if (newdata.length > 0) {
      dataToRender = loadpieChart();
    }
    return dataToRender;
  
};
